/// <reference path='../../interfaces/interfaces.d.ts' />

'use strict';

export default class CalendarController {

    public static $inject = [
        'Employee'
    ];

    public currentDate: string;
    public currentViewType: string;


    public isHelping = false;
    public showOverlayCallOuts = false;

    public isTour;
    public isCurrent = -1;
    public hasPermission;

    public calState = false;
    public calLabel = 'Calendar View';
    public dayHighlight_Low = $('<div>', {class: 'fc-event-count fc-low'})
    public dayHighlight_Med = $('<div>', {class: 'fc-event-count fc-med'})
    public dayHighlight_High = $('<div>', {class: 'fc-event-count fc-high'})

    public calListFilters = {
        birthdays: {
            state: false,
            label: 'Birthdays'
        },
        leave: {
            state: false,
            label: 'Leave'
        },
        pastItems: {
            state: false,
            label: 'Past Items'
        }
    };

    public calListDateRanges = ['All Calendars', 'My Calendar', 'Managers Calendar', 'Subordinate Calendar'];
    public selectedRange = 'All Calendars';

    constructor(public $uibModal: any,
                public uiCalendarConfig: any,
                public $state: angular.ui.IStateService,
                public Employee: IEmpService,
                public User: IUserService
            ) {
        document.body.scrollTop = document.documentElement.scrollTop = 0;
        this.hasPermission = User.hasPermission;


        window.onload = () => {
            $("[style='background-color:rgba(168, 168, 168,0.50); border-color:rgba(168, 168, 168,0.50)']")
                .css('cursor', 'context-menu');
        };
    }

    /**
     * Switch month
     * @param direct {string} - prev | next
     */
    public changeMonth(direct: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar(direct);
    }

    public changeViewType(type: string): void {
        this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('changeView', type);
    }

    public viewRender = (view: any) => {
        this.currentDate = this.makeTitle(view);
        this.currentViewType = view.intervalUnit;
        this.currentViewType = this.currentViewType[0].toUpperCase() + this.currentViewType.slice(1);
    }

    public dayRender = (date, cell) => {
        // let dayOfMonth = date.date();
        // let dayHighlight = this.dayHighlight_Low;
        // if (dayOfMonth >= 10 && dayOfMonth < 20) {
        //     dayHighlight = this.dayHighlight_Med;
        // } else if (dayOfMonth >= 20) {
        //     dayHighlight = this.dayHighlight_High;
        // } else {
        // }
        // dayHighlight.clone().appendTo(cell);
    }

    /**
     * Callback for click on day
     * @param date {date}
     */
    public clickOnDay = (date: moment.Moment) => {
        if (date === undefined) {
            date = moment();
        }
        let modalInstance: any = this.$uibModal.open({
            animation: true,
            controller: 'NewModalEventController as C',
            templateUrl: '/static/templates/modals/newEvent.html',
            resolve: {
                selectedDate: (): any => {
                    date.local();
                    date.hour(moment().hour()).minute(moment().minute());
                    return date;
                }
            }
        });

        modalInstance.result.then((event: any) => {
            event.color = this.getColor(event.calendar_type);
            this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
        });
    }

    public clickOnEvent = (event: IEvent) => {
        // skip edit page for leave items
        if (event.calendar_type === 'leaves') {
            return;
        }
        // open edit modal
        let modalInstance: any = this.$uibModal.open({
            controller: 'EditModalEventController as C',
            resolve: { event: (): any => { return event; } },
            templateUrl: '/static/templates/modals/editEvent.html'
        });

        modalInstance.result.then((selectedEvent: any) => {
            if (selectedEvent) {
                selectedEvent.color = this.getColor(selectedEvent.calendar_type);
                // selectedEvent.start.local();
                // selectedEvent.end.local();
                this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('updateEvent', selectedEvent);
            }
            this.uiCalendarConfig.calendars.currentCalendar.fullCalendar('refetchEvents');
        });
    }

    public getColor(eventType: string): string {
        let color: string;
        switch (eventType) {
            case 'Business Travel': {
                color = 'rgb(233,233,234)';    
                break; 
            } 
            case 'Performance Review': {
                color = 'rgb(233,203,209)';
                break;
            } 
            case 'HR Appointment': {
                color = 'rgb(234,239,248)';
                break;
            } 
            case 'Work Event': {
                color = 'rgb(191,208,230)';
                break;
            } 
            case 'Industry specific leave': {
                color = 'rgb(211,225,238)';
                break;
            } 
            case 'Recruitment': {
                color = 'rgb(121,143,140)';
                break;
            } 
            case 'Conference': {
                color = 'rgb(167,196,222)';
                break;
            } 
            case 'Training': {
                color = 'rgb(118,193,209)';
                break;
            } 
            case 'Personal Event': {
                color = 'rgb(215,234,234)';
                break;
            } 
            case 'Dependant Birthday': {
                color = 'rgb(172,219,223)';
                break;
            } 
            case 'unpaid': {
                color = 'rgba(214,110,117,0.6)';
                break;
            } 
            case 'compassionate': {
                color = 'rgba(214,110,117,0.6)';
                break;
            }
            case 'paid': {
                color = 'rgba(87,176,107,0.6)';
                break;
            } 
            case 'sick': {
                color = 'rgba(122,113,170,0.6)';
                break;
            } 
            case 'work from home': {
                color = 'rgba(233,246,128,0.6)';
                break;
            }
            case 'maternity': {
                color = 'rgba(255,211,78,0.6)';
                break;
            } 
            case 'paternity': {
                color = 'rgba(255,211,78,0.6)';
                break;
            } 
            case 'pending': {
                color = 'rgba(255,236,34,0.8)';
                break;
            }
            default: {
                color = 'rgba(116,129,141,0.6)';
                break;
            } 
        }
        return color;
    }

    public makeTitle(view: any): string {
        let start: moment.Moment = view.intervalStart;
        let end: moment.Moment = view.intervalEnd;
        let title: string;

        switch (view.intervalUnit) {
            case 'month': {
                title = view.intervalStart.format('MMMM YYYY');
                break;
            } 
            // parsing title
            case 'week': {
                if (start.year() !== end.year()) {
                    title = `${start.format('MMM DD YYYY')} - ${end.subtract(1, 'day').format('MMM DD YYYY')}`;
                } else {
                    if (start.month() !== end.month()) {
                        title = `${start.format('MMM DD')} - ${end.subtract(1, 'day').format('MMM DD, YYYY')}`;
                    } else {
                        title = `${start.format('MMM DD')} - ${end.subtract(1, 'day').format('DD, YYYY')}`;
                    }
                }
                break;
            }

            case 'day': {
                title = `${start.format('MMMM DD, YYYY')}`;
                break;
            } 
            default: {
                title = '';
            }
        }
        return title;
    }

    public fullEventEditor = () => {
        switch (this.$state.$current['self']['name']) {
            case 'root.calendar': {
                this.$state.go('root.calendar.add');
                break;
            } 
            case 'root.employees.details.calendar': {
                this.$state.go('root.employees.details.calendar.add');
                break;
            } 
            default: {
                this.$state.go('root');
            }
        }
    }

    public nextCallout (params: any): any {
        if (this.hasPermission(params)) {
        } else if (!this.hasPermission(params)) {
            this.isCurrent = this.isCurrent + 1;
        } else if (params === 'all') {
            this.isCurrent = this.isCurrent + 1;
        }
    }

    public startCallouts = () => {
        if (this.isHelping) {
            if (this.isTour === true) {
                this.Employee.setCoTourStatus(false);
                this.isTour = this.Employee.getCoTourStatus();
            }
            this.isHelping = false;
            this.showOverlayCallOuts = false;
            this.isCurrent = -1;
        } else if (!this.isHelping) {
            this.isHelping = true;
            this.showOverlayCallOuts = true;
            this.isCurrent = 0;
        }
    }

    public changeDate(params: string): any {
        this.selectedRange = params;
    }

    public filterList(): any {
        // replace with call to api
    }

    public eventRender(event: any, element: any, calendar: any): any {
        if (event.end) {
            let eventTime: number = event.end.diff(event.start);
            let fullDay: number = 86340000;
            let bulletColor: string = event.bulletColor;
            let bulletEle: string = `<span class="fc-event-bullet" style="background-color:${bulletColor}">&nbsp;</span>`;

            if (eventTime === fullDay) {
                element.find('.fc-time').hide();
            }
            if (eventTime < fullDay) {
                if (calendar.type === 'month') {
                    // display single day events with a bullet per item
                    element.find('.fc-content').prepend(bulletEle);
                } else {
                    element.css('background-color', event.bulletColor, 'border-color', event.bulletColor);
                }
            }
        }
    }
}



// WEBPACK FOOTER //
// ./frontend/scripts/calendar/controllers/calendar.controller.ts